import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

export const useBrandStoreData = (params: { entityId?: string; categoryId?: number }) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);

  return queryOptions({
    queryKey: [
      {
        entity: "storeData",
        params,
      },
    ],
    queryFn: async () =>
      await apiClient.getStoreData({
        queries: {
          entityid: params.entityId,
          categoryid: params.categoryId,
          market_place: marketPlace,
          pages_only: "true",
        },
      }),
    staleTime: 60 * 60 * 1000,
    retry: 3,
  });
};
